import { Controller } from "@hotwired/stimulus"

// Step-by-step navigation for the property listing form. Cards are tagged
// with data-step="<step-name>"; this controller hides all but the active
// step, drives the nav pills, and swaps Next/Previous/Submit buttons.
// The wizard is opt-in (data-controller="property-wizard" on the form) —
// expert mode skips this entirely.
export default class extends Controller {
  static values = { steps: Array, step: String }
  static targets = ["nav", "previous", "next", "submitButtons"]

  connect() {
    this.steps = this.stepsValue?.length
      ? this.stepsValue
      : ["basics", "location", "activities", "pricing", "photos", "access", "review"]
    this.current = this.stepValue && this.steps.includes(this.stepValue)
      ? this.stepValue
      : this.steps[0]
    this.render()
  }

  goTo(event) {
    event.preventDefault()
    const target = event.currentTarget.dataset.stepGoto
    if (this.steps.includes(target)) {
      this.current = target
      this.render({ scroll: true })
    }
  }

  next(event) {
    event.preventDefault()
    const i = this.steps.indexOf(this.current)
    if (i < this.steps.length - 1) {
      this.current = this.steps[i + 1]
      this.render({ scroll: true })
    }
  }

  previous(event) {
    event.preventDefault()
    const i = this.steps.indexOf(this.current)
    if (i > 0) {
      this.current = this.steps[i - 1]
      this.render({ scroll: true })
    }
  }

  render({ scroll = false } = {}) {
    this.element.querySelectorAll("[data-step]").forEach((el) => {
      el.classList.toggle("d-none", el.dataset.step !== this.current)
    })

    this.element.querySelectorAll("[data-step-goto]").forEach((el) => {
      el.classList.toggle("active", el.dataset.stepGoto === this.current)
    })

    const i = this.steps.indexOf(this.current)
    const onFirst = i === 0
    const onLast = i === this.steps.length - 1

    if (this.hasPreviousTarget) this.previousTarget.classList.toggle("d-none", onFirst)
    if (this.hasNextTarget) this.nextTarget.classList.toggle("d-none", onLast)
    if (this.hasSubmitButtonsTarget) this.submitButtonsTarget.classList.toggle("d-none", !onLast)

    if (scroll) window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
